<template>
  <div class="constrain mt-4 lg:mt-24 relative z-20">
    <div class="text-center max-w-3xl m-auto">
      <h1 class="heading-1 pb-6">ABOUT US</h1>
      <p class="text-grey-dark">Justhire was started with a mission to make hiring equipment easy. We wanted a one stop shop for everyone’s needs. One marketplace to hire all your equipment!</p>
    </div>

    <!-- Team Grid -->
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-12 mt-4 lg:mt-16 mb-12">
      <div
        v-for="(usp, index) in blok.members"
        :key="index"
        class="text-center border border-[#F9FAFB] rounded-2xl p-4 bg-white flex flex-col items-center justify-start space-y-4"
      >
        <!-- Step icon -->
        <div>
          <NuxtImg
            provider="storyblok"
            :src="usp.image.filename"
            :alt="getImageAlt(usp.image)"
            loading="lazy"
            format="webp"
            width="250px"
            height="250px"
            class="rounded-xl"
          />
        </div>

        <div class="flex flex-col items-center">
          <h5 class="subtitle-4 text-center font-bold">{{ usp.name }}</h5>
          <p class="text-[#938394] text-md font-normal text-center mt-2">{{ usp.title }}</p>
        </div>
      </div>
    </div>

    <TrustpilotGreenBlock class="max-w-2xl m-auto"/>

  </div>

  <Gradients :gradients="blok.gradients" />
</template>
<script setup lang="ts">
const props = defineProps({ blok: Object });

const { getImageAlt } = useImageAlt();
</script>
